module.exports = __webpack_public_path__ + "img/656.17855577.png";